<div class="products-footer-content">
    <section class="products montserrat">
        <div class="title col-6 mt-xl-5 mt-lg-5 mt-md-5 mt-sm-3 mt-3 pt-5 wrapper marginauto text-center">I NOSTRI INTEGRATORI</div>
        <div class="divider my-5 w-50 marginauto"></div>
        <div class="cards wrapper my-5 text-justify marginauto">
            <div class="row">

                <a class="float-left col-xl-4 col-lg-4 col-md-4 col-sm-8 col-10 pb-4 marginauto" href="https://shop.leonelifestyle.com/prodotti/protocollo-dimagrante/l-drena-200ml" target="_blank">
                    <div class="card marginauto">
                        <img class="lazyload card-img-top pt-3" data-src="./assets/products/L-Drena-sm.jpg" alt="L-Drena" title="L-Drena">
                        <div class="card-body text-center">
                            <h4 class="card-title">L-DRENA</h4>
                            INTEGRATORE ALIMENTARE<br>A BASE DI ESTRATTI VEGETALI<br>200 ML
                            <p class="card-text mt-3">31.90 €</p>
                        </div>
                    </div>
                </a>

                <a class="float-left col-xl-4 col-lg-4 col-md-4 col-sm-8 col-10 pb-4 marginauto" href="https://shop.leonelifestyle.com/prodotti/protocollo-dimagrante/l-detox-200ml" target="_blank">
                    <div class="card marginauto">
                        <img class="lazyload card-img-top pt-3" data-src="./assets/products/L-Detox-sm.jpg" alt="L-Detox" title="L-Detox">
                        <div class="card-body text-center">
                            <h4 class="card-title">L-DETOX</h4>
                            INTEGRATORE ALIMENTARE<br>A BASE DI ESTRATTI VEGETALI<br>200 ML
                            <p class="card-text mt-3">29.70 €</p>
                        </div>
                    </div>
                </a>

                <a class="float-left col-xl-4 col-lg-4 col-md-4 col-sm-8 col-10 pb-4 marginauto" href="https://shop.leonelifestyle.com/categoria-prodotto/integratori/" target="_blank">
                    <div class="card marginauto">
                        <img class="lazyload card-img-top pt-3" data-src="./assets/products/L-Amino-sm.jpg" alt="L-Amino" title="L-Amino">
                        <div class="card-body text-center">
                            <h4 class="card-title">L-AMINO</h4>
                            INTEGRATORE ALIMENTARE<br>A BASE DI AMMINOACIDI ESSENZIALI<br>960 GR, 60 PORZIONI
                            <p class="card-text mt-3">158.00 €</p>
                        </div>
                    </div>
                </a>

            </div>
        </div>
    </section>

    <section class="products montserrat">
        <div class="title col-6 mt-xl-5 mt-lg-5 mt-md-5 mt-sm-3 mt-3 pt-5 wrapper marginauto text-center">I NOSTRI MIX DI FARINE CON AMIDO RESISTENTE</div>
        <div class="divider my-5 w-50 marginauto"></div>
        <div class="cards wrapper my-5 text-justify marginauto">
            <div class="row">

                <a class="float-left col-xl-4 col-lg-4 col-md-4 col-sm-8 col-10 pb-4 marginauto" href="https://shop.leonelifestyle.com/prodotti/protocollo-dimagrante/mix-pane-e-pizza-low-carb-keto-1kg" target="_blank">
                    <div class="card marginauto">
                        <img class="lazyload card-img-top pt-3" data-src="./assets/products/mix-pane-e-pizza-low-carb-keto.jpg" alt="MIX PANE E PIZZA LOW CARB" title="MIX PANE E PIZZA LOW CARB">
                        <div class="card-body text-center">
                            <h4 class="card-title">MIX PANE E PIZZA LOW CARB</h4>
                            FARINA KETO 1 KG
                            <p class="card-text mt-3">16.80 €</p>
                        </div>
                    </div>
                </a>

                <a class="float-left col-xl-4 col-lg-4 col-md-4 col-sm-8 col-10 pb-4 marginauto" href="https://shop.leonelifestyle.com/prodotti/confezionati/confezionati-dolci/mix-pane-ai-semi-low-carb-keto-1-kg" target="_blank">
                    <div class="card marginauto">
                        <img class="lazyload card-img-top pt-3" data-src="./assets/products/mix-pane-ai-semi-low-carb-keto.jpg" alt="MIX PANE AI SEMI LOW CARB" title="MIX PANE AI SEMI LOW CARB">
                        <div class="card-body text-center">
                            <h4 class="card-title">MIX PANE AI SEMI LOW CARB</h4>
                            FARINA KETO 1 KG
                            <p class="card-text mt-3">16.80 €</p>
                        </div>
                    </div>
                </a>

                <a class="float-left col-xl-4 col-lg-4 col-md-4 col-sm-8 col-10 pb-4 marginauto" href="https://shop.leonelifestyle.com/prodotti/confezionati/confezionati-dolci/mix-pasta-fresca-low-carb-keto-1kg" target="_blank">
                    <div class="card marginauto">
                        <img class="lazyload card-img-top pt-3" data-src="./assets/products/mix-pasta-fresca-low-carb-keto.jpg" alt="MIX PASTA FRESCA LOW CARB" title="MIX PASTA FRESCA LOW CARB">
                        <div class="card-body text-center">
                            <h4 class="card-title">MIX PASTA FRESCA LOW CARB</h4>
                            FARINA KETO 1 KG
                            <p class="card-text mt-3">14.60 €</p>
                        </div>
                    </div>
                </a>

                <div class="col-xl-6 col-lg-6 col-md-10 col-sm-10 col-10 text-center shipping-cost marginauto">
                    <div class="alert alert-success" role="alert">
                        <i class="fa fa-shopping-cart" aria-hidden="true"></i>
                        Spese di spedizione gratuite per ordini superiori a <strong>69 euro</strong>.
                    </div>
                </div>
            </div>
        </div>
    </section>

    <section class="my-5 montserrat">
        <div class="textblock wrapper marginauto">
            <div class="divider w-50 marginauto"></div>
        </div>
    </section>
</div>

<footer class="montserrat">
    <div class="row stripe no-gutters">
        <div class="col-12 py-3 wrapper marginauto">
            <div class="title col-xl-6 col-lg-6 col-md-6 col-sm-6 col-6 mt-2 float-left">
                CANALI UFFICIALI
            </div>

            <div class="social col-xl-6 col-lg-6 col-md-6 col-sm-6 col-6 float-left">
                <div class="float-right">
                    <a href="https://www.facebook.com/leonelifestyle1/" target="_blank">
                        <i class="fa fa-facebook text-center" aria-hidden="true"></i>
                    </a>

                    <a href="https://www.youtube.com/channel/UCWBXZGb94LVb97LmFSOf2SA" target="_blank">
                        <i class="fa fa-youtube text-center" aria-hidden="true"></i>
                    </a>

                    <a href="https://www.instagram.com/riccardo.ferrero.leone/" target="_blank">
                        <i class="fa fa-instagram text-center" aria-hidden="true"></i>
                    </a>
                </div>
            </div>
        </div>
    </div>

    <div class="row footerlink text-xl-left text-lg-left text-md-left text-sm-center text-center no-gutters">
        <div class="col-12 py-3 wrapper marginauto">

            <div class="col-xl-2 col-lg-2 col-md-2 float-left">
                <div class="title mb-xl-0 mb-lg-0 mb-md-0 mb-sm-2 mb-2">
                    CHI SONO
                </div>
                <a routerLink="/chi-sono">Ferrero Leone</a><br>
                <a data-toggle="modal" data-target="#workinprogress">Curriculum</a><br>
                <a data-toggle="modal" data-target="#workinprogress">FAQ</a>
            </div>

            <div class="col-xl-2 col-lg-2 col-md-3 float-left">
                <div class="title mt-xl-0 mt-lg-0 mt-md-0 mt-sm-4 mt-4 my-xl-0 my-lg-0 my-md-0 my-sm-2 my-2">
                    PRIVACY E POLICY
                </div>
                <a href="/cookie" target="_blank">Cookie Policy</a><br>
                <a data-toggle="modal" data-target="#workinprogress">Note Legali</a><br>
                <a data-toggle="modal" data-target="#workinprogress">Termini e condizioni</a>
            </div>

            <div class="col-xl-2 col-lg-2 col-md-2 float-left">
                <div class="title mt-xl-0 mt-lg-0 mt-md-0 mt-sm-4 mt-4 my-xl-0 my-lg-0 my-md-0 my-sm-2 my-2">
                    LA SCIENZA
                </div>

                <a class="selected" routerLink="/dieta-chetogenica" routerLinkActive="router-link-active">Dieta Chetogenica</a><br>
                <a class="selected" routerLink="/blog" routerLinkActive="router-link-active">Blog La Scienza</a><br>
                <a class="selected" routerLink="/approfondimenti">Approfondimenti</a><br>
                <a class="selected" routerLink="/partner" routerLinkActive="router-link-active">Partner</a>
            </div>

            <div class="col-xl-2 col-lg-2 col-md-2 float-left">
                <div class="title mt-xl-0 mt-lg-0 mt-md-0 mt-sm-4 mt-4 my-xl-0 my-lg-0 my-md-0 my-sm-2 my-2">
                    CONTATTACI
                </div>
                <a data-toggle="modal" data-target="#workinprogress">Consigli</a><br>
                <a data-toggle="modal" data-target="#workinprogress">Servizio Clienti</a><br>
            </div>

            <div class="social col-xl-4 col-lg-4 col-md-3 col-sm-12 col-12 my-xl-0 my-lg-0 my-md-0 my-sm-5 my-5 float-left no-gutters marginauto">
                <div class="logo-small float-xl-right float-lg-right float-md-right float-sm-none float-none">
                    <img class="lazyload" data-src="./assets/logo-small.svg" width="100%" height="120px">
                </div>
            </div>
        </div>
    </div>

    <div class="row stripe no-gutters">
        <div class="col-12 py-3 wrapper marginauto">

            <div class="social col-xl-12 col-lg-12 col-md-12 col-sm-12 col-12 mt-xl-0 mt-lg-0 mt-md-3 float-left no-gutters marginauto">
                <div class="float-xl-right float-lg-right float-md-right float-sm-none float-none">
                    <span class="credits">
                        <div class="font-weight-bold">AVVERTENZE</div>
                        <span class="text-justify">
                            Tutti i contenuti presentati in questo sito sono di carattere puramente informativo e non possono essere intesi in alcun modo come prescrizioni di tipo medico né possono essere ad esse sostituite. Queste spettano esclusivamente ai professionisti abilitati che possano valutare eventuali rischi collaterali. Autori e proprietari del sito declinano ogni responsabilità per eventuali danni diretti o indiretti derivanti dall'utilizzo di queste informazioni senza il necessario controllo medico.
                        </span>
                    </span>
                </div>
            </div>

        </div>
    </div>

    <div class="row footerlink no-gutters">
        <div class="col-12 wrapper marginauto">
            <div class="credits col-12 float-left py-3">
                <div class="text-xl-left text-lg-left text-md-left text-sm-center text-center">
                    <a data-toggle="modal" data-target="#workinprogress">Guida</a> | <a data-toggle="modal" data-target="#workinprogress">Condizioni d'uso</a> | <a data-toggle="modal" data-target="#workinprogress">Info Legali e Societarie</a>
                    <!-- | <a data-toggle="modal" data-target="#workinprogress">Politica sulla privacy e sui cookie</a> | <a data-toggle="modal" data-target="#workinprogress">Impostazioni cookie</a> -->
                </div>

                <div class="text-xl-left text-lg-left text-md-left text-sm-center text-center pt-xl-0 pt-lg-0 pt-md-0 pt-sm-3 pt-3">
                    {{ now }} &copy; Leone lifestyle | Ferrero Consulting Srls - P.IVA 13561411003 | <a href="mailto:info@leonelifestyle.com">info@leonelifestyle.com</a> | developed by <a href="https://deanvial.com" target="_blank">Dean&Vial srls</a>
                </div>
            </div>
        </div>
    </div>

    <div class="row">
        <div class="col-12 totop"></div>
    </div>
</footer>

<!-- Modal -->
<div class="modal fade" id="workinprogress" tabindex="-1" role="dialog" aria-labelledby="workinprogressTitle" aria-hidden="true">
    <div class="modal-dialog modal-dialog-centered" role="document">
      <div class="modal-content">
        <div class="modal-header">
          <h2 class="modal-title" id="workinprogressTitle">Pagina in Costruzione</h2>
          <button type="button" class="close" data-dismiss="modal" aria-label="Close">
            <span aria-hidden="true">&times;</span>
          </button>
        </div>
        <div class="modal-body montserrat">
            Il contenuto che state cercando non è al momento disponibile.
        </div>
        <div class="modal-footer montserrat">
          <button type="button" class="list-group-item list-group-item-action inverted w-50 text-center" data-dismiss="modal">Chiudi</button>
        </div>
      </div>
    </div>
  </div>
